import logo from "./media/hmc-logo.png";
import backgroundImage from "./media/background.jpg";
import footerLogo from "./media/powered-by-healo.png";
import constants from "../../../../common/constants";
import SV_TRANSLATION from "../default/messages/sv";
import EN_TRANSLATION from "../default/messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "hmc",
  image: logo,
  imagePost: logo,
  backGroundVideo: null,
  appBackground: {
    url: backgroundImage,
    overlayStyle: {
      // mixBlendMode: "soft-light",
      backgroundColor: "rgba(211, 228, 133, 0.9)"
    }
  },
  secondaryBackground: {
    backgroundColor: "rgba(211, 228, 133, 0.9)",
    gradientColors: ["rgba(211, 228, 133, 0.9)", "rgba(211, 228, 133, 0.75)"]
  },
  footerImage: footerLogo,
  baseClass: "hmc",
  domains: [
    "http://localhost:4001",
    "https://dev-hmc.healo.app",
    "https://stg-hmc.healo.app",
    "https://hmc.healo.app"
  ],
  clinicCityEnabled: true,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1399 : 1106,
  ssnEnabled: true,
  anonymousEnabled: false,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  },
  downloadLinks: {
    ios:
      "https://apps.apple.com/us/app/hmc-rehab/id1629585545#?platform=iphone",
    android:
      "https://play.google.com/store/apps/details?id=se.halsomedicinsktcenter.rehab"
  },
  defaultLanguage: [
    {
      test: [".*"],
      language: constants.appLanguages.sv
    }
  ]
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/hmc/settings.js